export default __webpack_public_path__ + "static/media/Receba.014ab4a1.svg";